import React from 'react'

import ProgressBar from './commons/ProgressBar'

class Navbar extends React.Component {
  render() {
    return(
      <div>
        <div className='navbar navbar-expand-lg fixed-top' >
          <a className='navbar-brand'>
            <img src={this.props.logoUrl} alt='' />
          </a>
          <div className='navbar-nav mr-auto'>

          </div>
          <span className='navbar-text'>
            <a href='/logout'>Save and exit</a>
          </span>
        </div>
        <ProgressBar />
      </div>
      )
  }
}

export default Navbar;
